import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  // Whether the user navigated to add a new asset from inside a Retirement goal form
  isFromRetirementGoal: false,
  // The active tab name when the user left the goal form
  savedActiveTabName: null,
  // The current submitBody / form payload when the user left the goal form
  savedFormData: {},
  // The currently assigned assets when the user left the goal form
  savedAssetsAssign: [],
};

const goalFormSlice = createSlice({
  name: "goalForm",
  initialState,
  reducers: {
    /**
     * Call this just before navigating away to create an asset from a Retirement goal.
     * Saves the current form state so we can restore it when the user returns.
     */
    saveGoalFormState: (state, { payload }) => {
      state.isFromRetirementGoal = true;
      state.savedActiveTabName = payload.activeTabName || null;
      state.savedFormData = payload.formData || {};
      state.savedAssetsAssign = payload.assetsAssign || [];
    },
    /**
     * Call this after the goal is successfully created (or when the user explicitly
     * cancels the return flow) to wipe persisted state.
     */
    clearGoalFormState: (state) => {
      state.isFromRetirementGoal = false;
      state.savedActiveTabName = null;
      state.savedFormData = {};
      state.savedAssetsAssign = [];
    },
  },
});

export const { saveGoalFormState, clearGoalFormState } = goalFormSlice.actions;

export default goalFormSlice.reducer;
